/* eslint-disable react/no-unescaped-entities */

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  HStack,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import { AboutData, AboutDataKeys } from '../components/about/data';
import Footer from '../components/footer/Footer';
import Navbar from '../components/navbar';

/* eslint-disable @next/next/no-img-element */
const About = () => {
  return (
    <div
      style={{
        overflowX: 'hidden',
      }}
    >
      <Navbar />
      <VStack
        // bg="black"
        minH={'100vh'}
        gap="2em"
        minW="100vw"
        maxW="100vw"
        h="max-content"
        py="5em"
        overflow={'hidden'}
      >
        <VStack
          w={'full'}
          px="4em"
          gap="3em"
          //   bg="red"
          maxW={'90vw'}
          overflow="hidden"
        >
          <HStack gap="2em" alignItems={'flex-start'}>
            <VStack alignItems={'flex-start'}>
              <Text fontWeight={'extrabold'} borderBottom="1px solid black">
                About Us
              </Text>
              <Text fontSize={'2em'} fontWeight="extrabold">
                Welcome to Vital Educators
              </Text>
              <Text fontSize={'.9em'} color="#505050">
                Vital Educator was established to empower young individuals in
                our society. We do this by providing fantastic coaches and
                tutors in your local area to help and guide you through your
                education. For extra support, we also provide free, detailed
                exam-related content for GCSEs and A-levels. You can also find
                our career-based podcast in our blog section, which is filled
                with real-life practical advice. Through our podcast, we aim to
                provide valuable insights into the lives of working
                professionals of our society. This makes us the first company of
                its kind that provides all the necessary steps, contents and
                services to prepare students for next phase of their lives.
              </Text>
            </VStack>
            <Image
              src="https://vitaleducators.com/front/images/about/about-2.jpg"
              alt="iamge"
            />
          </HStack>
          {Object.keys(AboutData).map((key, idx) => (
            <VStack w="full" alignItems={'flex-start'} key={idx}>
              <Text fontSize="1.2em" fontWeight={'extrabold'}>
                {key.toUpperCase()}
              </Text>
              <Accordion allowMultiple w="full">
                {AboutData[key as AboutDataKeys].map((item, idx) => (
                  <AccordionItem key={idx}>
                    <h2>
                      <AccordionButton borderLeft={'2px solid blue'}>
                        <Box flex="1" textAlign="left">
                          {item.title}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>{item.content}</AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </VStack>
          ))}
        </VStack>
      </VStack>
      <Footer />
    </div>
  );
};

export default About;
